import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface DialogResultEvent<T = any> {
  source: string;   // identifies compoent to trigger result
  data: T;
}

export interface FileFlags {
  isNewApp?: boolean;
  isSahaFile?: boolean;
  // You can easily add more feature flags here later
}

@Injectable({ providedIn: 'root' })

export class AgreementLoanCalculatorService {  
  private dialogResult = new Subject<DialogResultEvent>();
  private fileStateMap = new Map<string, FileFlags>();   

  dialogResult$ = this.dialogResult.asObservable();  

  emitResult(source: string, data: any) {
    this.dialogResult.next({ source, data }); 
  }

  getConfig(indicator: keyof FileFlags, fileId: string): boolean | undefined {
    const fileState = this.fileStateMap.get(fileId);
    return fileState ? fileState[indicator] : undefined;
  }

  setConfig(indicator: keyof FileFlags, fileId: string, value: boolean): void {
    const currentState = this.fileStateMap.get(fileId) || {};
    
    this.fileStateMap.set(fileId, {
      ...currentState,
      [indicator]: value
    });
  }

  clearAllForFile(fileId: string): void {
    this.fileStateMap.delete(fileId);
  }
}